<template>
  <div
    class="svgDiv"
    :style="{ width: width, height: height }"
    v-if="selected_icon_content"
    v-html="selected_icon_content"
  ></div>
</template>

<script>
export default {
  name: "SVGLoader",
  props: {
    src: {
      type: String,
      required: true
    },
    fill: {
      type: String
    },
    width: {
      type: String,
      default: "24px"
    },
    height: {
      type: String,
      default: "24px"
    }
  },
  data() {
    return {
      icon_width: "24px",
      icon_height: "24px",
      selected_icon_content: ""
    };
  },
  created() {
    this.load_icon();
  },
  methods: {
    load_icon() {
      fetch(this.src)
        .then((response) => response.text())
        .then((svgContent) => {
          this.parse_svg_content(svgContent);
        })
        .catch((error) => {
          console.error(`Erro ao carregar o SVG: ${error}`);
        });
    },
    parse_svg_content(svgContent) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgContent, "image/svg+xml");
      const svgElement = doc.documentElement;

      svgElement.setAttribute("width", this.width);
      svgElement.setAttribute("height", this.height);

      if (this.fill) {
        svgElement.setAttribute("fill", this.fill);
        const paths = svgElement.querySelectorAll("path");
        for (const path of paths) {
          path.setAttribute("fill", this.fill);
        }
      }

      const newSVG = new XMLSerializer().serializeToString(svgElement);
      // Atualiza o conteúdo do SVG
      this.selected_icon_content = newSVG;
    }
  },
  watch: {
    src: "load_icon",
    width: "load_icon"
  }
};
</script>
<style scoped>
.svgDiv {
  display: flex;
}
</style>
